<template>
  <date-picker
    class="otb-range-date-picker__input"
    :formLabel="formLabel"
    :labelPlaceholder="labelPlaceholder"
    :rangePicker="rangePicker"
    :selectedDates="selectedDates"
    :selectedDay="selectedDay"
    :pickerVisibility="pickerVisibility"
    :isMobile="isMobile"
    :dealerCalendar="dealerCalendar"
    :calendarStartDate="calendarStartDate"
    :activeTextCarouselSlide="activeCarouselSlide"
    @onPickerToggle="onPickerToggle($event, rangePicker.workingMode)"
    @changeDate="changeDate"
    @maskCalendar="maskCalendarSection"
    @unmaskCalendar="unmaskCalendarSection"
    @changeSheet="changeSheet"
  >
    <template #supportContent>
      <time-picker
        :selectedTime="selectedTime"
        :availableTime="availableTime"
        :hourPlaceholder="hourPlaceholder"
        @changeTime="changeTime($event, rangePicker.workingMode)"
      >
      </time-picker>
    </template>
  </date-picker>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import { TimeOption } from '../../models/entities/timeslot.model';
import {
  DatesAvailabilityType,
  DateRangeMode,
  DateWorkingMode,
} from '../../models/entities/calendar.model';

import useCalendarPicker from '../../composables/calendar-picker.composable';

export default defineComponent({
  name: 'otb-calendar-picker',
  components: {
    DatePicker: () => import('../date-picker/index.vue'),
    TimePicker: () => import('../time-picker/index.vue'),
  },
  props: {
    activeTextCarouselSlide: Number,
    availableTime: Array as () => TimeOption[],
    calendarStartDate: {
      type: Date,
      default() {
        return new Date();
      },
    },
    dealerCalendar: Object as () => DatesAvailabilityType,
    formLabel: String,
    hourPlaceholder: String,
    isMobile: Boolean,
    labelPlaceholder: String,
    pickerVisibility: Boolean,
    rangePicker: {
      type: Object as () => { enabled: boolean; workingMode: DateWorkingMode },
      default() {
        return { enabled: true, workingMode: DateWorkingMode.START };
      },
    },
    selectedDates: {
      type: Object as () => DateRangeMode,
      default() {
        return {};
      },
    },
    selectedDay: {
      type: Date,
      default() {
        return new Date();
      },
    },
    selectedTime: Object as () => TimeOption,
  },
  setup(_props, { emit }) {
    const CalendarPicker = useCalendarPicker({ emit });

    return {
      ...CalendarPicker,
    };
  },
});
</script>
<style src="./calendar-picker.scss" lang="scss"></style>
